import { Injectable, inject, signal } from '@angular/core';
import { FloatingPanelService } from '@shared/floating-panel/floating-panel.service';
import { HdGateInfoOpenBehavior } from '../../chart/bodygraph/gate-info/hd-gate-info-requested-context.model';
import { loadHdChartGlobalSettings } from '../../chart/bodygraph/chart-tabs/hd-chart-global-settings';
import { HdLineTextReviewAccessService } from '../hd-line-text-review-access.service';
import { HdLineTextReviewPanelComponent } from './hd-line-text-review-panel.component';
import { HD_LINE_TEXT_REVIEW_PANEL_KEY } from './hd-line-text-review-panel.models';

/**
 * Opent het reviewoverzicht van de eigen lijnteksten (één paneel, key
 * `line-text-review`), gedockt of als dialoog volgens de globale
 * `gateInfoOpenBehavior`-setting die de chart-pagina live doorgeeft (zelfde
 * patroon als het Line Companion-paneel). Zonder de reviewfeature is openen
 * een no-op.
 */
@Injectable({ providedIn: 'root' })
export class HdLineTextReviewPanelService {
  private readonly floatingPanels = inject(FloatingPanelService);
  private readonly access = inject(HdLineTextReviewAccessService);

  private readonly openBehavior = signal<HdGateInfoOpenBehavior>(
    loadHdChartGlobalSettings().gateInfoOpenBehavior,
  );

  /** Live-sync van de `gateInfoOpenBehavior`-setting door de chart-pagina. */
  setOpenBehavior(behavior: HdGateInfoOpenBehavior): void {
    this.openBehavior.set(behavior);
  }

  openOverview(origin?: { x: number; y: number }): void {
    if (!this.access.featureGranted()) {
      return;
    }
    const behavior = this.openBehavior();
    const docked = behavior === 'full-docked-keep' || behavior === 'full-docked-autoclose';

    this.floatingPanels.openOrFocus<HdLineTextReviewPanelComponent, undefined>({
      key: HD_LINE_TEXT_REVIEW_PANEL_KEY,
      component: HdLineTextReviewPanelComponent,
      data: undefined,
      dockTab: { label: 'RV', icon: 'clipboard-check' },
      dockZone: 'full',
      openInitiallyDocked: docked,
      redockOnReopen: docked,
      startPosition: origin != null ? { preferred: origin, hint: 'prefer-right-of-anchor' } : 'center',
    });
  }
}
